import { createContext } from 'react';
import type { IEntityFieldProviderContext } from './types';

export const EntityFieldContext = createContext({} as IEntityFieldProviderContext);
